import React from "react";
import { VoiceTemplateItemData } from "@/services/user-audio-template-list";
import { VoiceCard } from "@/components/assets-voice/voice-card";
import { useTranslation } from "react-i18next";
import { ChevronLeftThinIcon } from "../ui/icon";
import { TemplateEmpty2Icon } from "../agent-dashboard-user-detail/assets";
import { VoiceAddButton } from "../agent-creation/voice-add-button";

export interface VoicesCarouselProps {
  templates?: VoiceTemplateItemData[];
  loading?: boolean;
  saveLoading?: boolean;
  onAdd?: () => void;
  onOpenAll?: (templates: VoiceTemplateItemData[]) => void;
  onSaveVoiceTemplate?: (ids: string[]) => Promise<void>;
  onRemoveVoiceTemplate?: (id: string) => Promise<void>;
}

export const VoicesCarousel: React.FC<VoicesCarouselProps> = ({ templates = [], loading, saveLoading, onAdd, onOpenAll, onSaveVoiceTemplate, onRemoveVoiceTemplate }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-10">
      <div className="flex items-center justify-between mb-5">
        <div className="text-[15px] text-[rgba(16,24,40,1)] font-medium">{t("agent_creation.subscription_settings.voice")}</div>
        <button
          className="flex items-center gap-2"
          onClick={() => onOpenAll(templates)}
        >
          <span className="text-sm text-[rgba(102,112,133,1)]">
            {t("agent_creation.subscription_settings.total_items", { totalItems: templates.length })}
          </span>
          <ChevronLeftThinIcon className="w-5 h-5 text-[rgba(152,162,179,1)]" />
        </button>
      </div>

      <div className="flex flex-col gap-3">
        <VoiceAddButton
          voiceIds={templates?.map((item) => item.id)}
          saveLoading={saveLoading}
          onSave={onSaveVoiceTemplate}
        />
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-[76px] w-full rounded-xl border border-[#eaecf0] bg-gray-200 animate-pulse" />
          ))
        ) : (
          templates?.length ? templates.slice(0, 4).map((v, i) => (
            <VoiceCard
              showEdit={false}
              showRemove
              key={`${v.id}_${i}`}
              audio={{
                id: v.id,
                voiceTtsId: "",
                modelName: "",
                name: v.name,
                createdAt: v.createdAt,
                ageGroup: "",
                language: "",
                gender: "",
                speed: 1,
                audioUrl: v.sampleUrl,
                isStarred: false,
              }}
              onRemove={onRemoveVoiceTemplate}
            />
          )) : (
            <div className='w-full h-full relative  flex flex-col justify-center items-center col-span-full my-7'>
              <TemplateEmpty2Icon className='w-[198px]' />
              <span className='text-base text-[rgba(102,112,133,1)]'>{t("agent_dashboard.user_detail.voice.voice_empty2")}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
};